import api from './api';

/** Clasificación de recetas (categoría → subcategoría → familia). Misma forma que `classificationService`, rutas bajo /recetas/. */
const recetaClassificationService = {
  async getCategories(params = {}) {
    const response = await api.get('/recetas/categories', { params });
    return response.data;
  },
  async getCategory(id) {
    const response = await api.get(`/recetas/categories/${id}`);
    return response.data;
  },
  async createCategory(data) {
    const response = await api.post('/recetas/categories', data);
    return response.data;
  },
  async updateCategory(id, data) {
    const response = await api.put(`/recetas/categories/${id}`, data);
    return response.data;
  },
  async deleteCategory(id) {
    const response = await api.delete(`/recetas/categories/${id}`);
    return response.data;
  },
  async getSubcategories(params = {}) {
    const response = await api.get('/recetas/subcategories', { params });
    return response.data;
  },
  async getSubcategory(id) {
    const response = await api.get(`/recetas/subcategories/${id}`);
    return response.data;
  },
  async createSubcategory(data) {
    const response = await api.post('/recetas/subcategories', data);
    return response.data;
  },
  async updateSubcategory(id, data) {
    const response = await api.put(`/recetas/subcategories/${id}`, data);
    return response.data;
  },
  async deleteSubcategory(id) {
    const response = await api.delete(`/recetas/subcategories/${id}`);
    return response.data;
  },
  async getFamilies(params = {}) {
    const response = await api.get('/recetas/families', { params });
    return response.data;
  },
  async getFamily(id) {
    const response = await api.get(`/recetas/families/${id}`);
    return response.data;
  },
  async createFamily(data) {
    const response = await api.post('/recetas/families', data);
    return response.data;
  },
  async updateFamily(id, data) {
    const response = await api.put(`/recetas/families/${id}`, data);
    return response.data;
  },
  async deleteFamily(id) {
    const response = await api.delete(`/recetas/families/${id}`);
    return response.data;
  },
  async getHierarchy(params = {}) {
    const response = await api.get('/recetas/hierarchy', { params });
    return response.data;
  },
  async getRecetaFormData(params = {}) {
    const response = await api.get('/recetas/form-data', { params });
    return response.data;
  },
};

export default recetaClassificationService;
